export default __webpack_public_path__ + "static/2-8f03bd2aede6d05b508048d80b4f1214.jpg";